import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Modal,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Alert,
  Fade,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import LockIcon from '@mui/icons-material/Lock';
import AccountCircle from '@mui/icons-material/AccountCircle';
import FeaturesSection from './FeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import CallToActionSection from './CallToActionSection';
import CourseCategoriesSection from './CourseCategoriesSection';
import { motion } from 'framer-motion';
import Slider from 'react-slick';
import ImageSlider from './ImageSlider';

function LoginPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  

const sliderImages = [
  '/unlock.png',
  '/unlock.png',
  '/unlock.png', // Add more paths as needed
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: false,
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('http://196.216.9.34:5020/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflowX: 'hidden' }}>
      {/* Background image */}
      <Box
        component="video"
        src="mbs building.mp4" // replace with your actual video path
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'fixed',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />


      {/* Gradient overlay */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.9))',
          zIndex: 1,
        }}
      />

      {/* Main Page Content */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          px: 2,
          textAlign: 'center',
        }}
      >
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="h3"
            sx={{
              mb: 2,
              fontWeight: 800,
              letterSpacing: 3,
              color: '#fff',
              textShadow: '0 0 12px rgba(0, 0, 0, 1)',
            }}
          >
            MBS E-LEARNING
          </Typography>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {/* <Typography variant="h5" sx={{ mb: 1, fontWeight: 500, color: '#fff' }}>
            Unlock Your Potential Through Smarter Learning
          </Typography> */}
          <Typography variant="subtitle1" sx={{ color: '#ddd', maxWidth: 600, mx: 'auto', mb: 4 }}>
            Discover courses, earn certificates, and connect with mentors — all in one powerful platform.
          </Typography>
        </motion.div>

        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          {/* <Box
            sx={{
              width: { xs: 180, sm: 220 },
              height: { xs: 90, sm: 100 },
              backgroundImage: "url('/logos/standardsLogo.png')",
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              mb: 2,
            }}
          /> */}
          {/* <Box
            sx={{
              width: { xs: 300, sm: 400 },
              height: { xs: 150, sm: 200 },
              backgroundImage: "url('/unlock.png')",
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              mb: 4,
            }}
          /> */}
          <ImageSlider />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <Button
            onClick={() => setModalOpen(true)}
            variant="contained"
            sx={{
              bgcolor: '#ff6600',
              px: 7,
              py: 2,
              borderRadius: '50px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              boxShadow: '0 4px 16px rgba(255,102,0,0.6)',
              '&:hover': {
                bgcolor: '#e65c00',
                boxShadow: '0 6px 20px rgba(230,92,0,0.8)',
              },
            }}
          >
            Get Started
          </Button>
        </motion.div>
      </Box>

      {/* Extra Content */}
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <FeaturesSection />
        <CallToActionSection />
        <CourseCategoriesSection />
      </Box>

      {/* Login Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} closeAfterTransition>
        <Fade in={modalOpen}>
          <Paper
            elevation={24}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 360,
              bgcolor: '#fff',
              borderRadius: 3,
              p: 4,
              boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
              outline: 'none',
            }}
          >
            <Typography
              variant="h5"
              sx={{ mb: 3, color: '#ff6600', fontWeight: 'bold', textAlign: 'center' }}
            >
              Login to Your Account
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                margin="normal"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle color="action" />
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                margin="normal"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon color="action" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end" size="large">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  py: 1.5,
                  backgroundColor: '#ff6600',
                  fontWeight: 'bold',
                  '&:hover': { bgcolor: '#e65c00' },
                }}
              >
                Log In
              </Button>
            </form>

            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              Don&apos;t have an account?{' '}
              <Box
                component="span"
                onClick={() => {
                  setModalOpen(false);
                  navigate('/register');
                }}
                sx={{ color: '#ff6600', cursor: 'pointer', fontWeight: 'bold' }}
              >
                Register
              </Box>
            </Typography>
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
}

export default LoginPage;
